// src/pages/CourseTime/styles/progress.styles.js
import styled from 'styled-components';
import RazProgressSVG from "../../../components/UI/SVG_IMGs/RazProgressSVG";

export const ProgressRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
  
  @media (max-width: 1024px) {
   flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const ProgressContainer = styled.div`
  margin: 0 auto;
  position: relative;
  background-color: #ddd;
  border-radius: 5px;
  width: 45vw;
  height: 3vh;
  margin-top: 4vh;
  
  @media (max-width: 768px) {
   width: 55vw;
    margin-right:118px;
  }
  
  @media (min-width:768px) and (max-width: 1024px) {
    margin-right: auto;
  }
`;

export const ProgressBar = styled.div`
  position: absolute;
  height: 100%;
  width: 0%;
  border-radius: 5px;
`;

export const ProgressMarker = styled(RazProgressSVG)`
  position: absolute;
  top: 0px;
  transform: translateX(-50%);
  height: 5vh !important;
  width: 16px;
  transition: left 0.3s ease;
  
  @media (max-width: 768px) {
    height: 3vh !important;
    width: 12px;
  }
`;

export const ProgressText = styled.p`
  position: absolute;
  font-weight: bold;
  left: 105%;
  width: 100%;
  margin: 0;
  font-size: 1.8em;
  line-height: 1em;
  
  @media (max-width: 1024px) {
    left: 110%;
  }
  @media (max-width: 768px) {
    left: 115%;
    font-size: 1.4em;
  }
`;

export const NextSessionContainer = styled.div`
  margin-left: auto;
  text-align: center;
  padding: 10px;
  
  ${props => props.completed && `
    background-color: #f0fff4;
    border-left: 4px solid #48bb78;
  `}
  
  p {
    font-size: 16px;
    color: #000;
    margin-bottom: 15px;
  }

  @media (max-width: 1024px) {
    margin-left: 0;
  }
`;

export const NextSessionButton = styled.button`
  background-color: #32BAF1;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background-color: #32BAF1;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const HomeButton = styled.button`
  background-color: #48bb78;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background-color: #38a169;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

// Full page overlay
export const FullPageOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  pointer-events: auto;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: ${props => props.sidebarCollapsed ? '60px' : '380px'};
  width: ${props => props.sidebarCollapsed ? 'calc(100vw - 60px)' : 'calc(100vw - 380px)'};
  height: 100vh;
  background: rgba(15, 23, 42, 0.2);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  pointer-events: auto;
  
  @media (max-width: 1024px) {
    left: ${props => props.sidebarCollapsed ? '10px' : '300px'};
    width: ${props => props.sidebarCollapsed ? 'calc(100vw - 10px)' : 'calc(100vw - 300px)'};
  }
  
  @media (max-width: 768px) {
    left: 0;
    width: 100vw;
  }
`;

export const PopupContainer = styled.div`
  position: relative;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  z-index: 1001; 
  width: 400px;
  text-align: center;
  @media (max-width: 768px) {
    width: 340px;
  }
`;



export const PopupButton = styled.button`
  background-color: ${({ themeColor }) => themeColor || '#32BAF1'};
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ themeColor }) => themeColor || '#2aa2d6'};
    opacity: 0.9;
    transform: translateY(-2px);
  }
  &:active {
    transform: translateY(0);
  }
`;

export const CloseIcon = styled.span`
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 22px;
  font-weight: bold;
  color: ${({ themeColor }) => themeColor || '#2aa2d6'};
  cursor: pointer;
  transition: color 0.2s ease;
  &:hover {
    opacity: 0.8;
  }
`;

